<div class="calendario-container">
  <!-- Header del calendario -->
  <div class="calendario-header">
    <button class="btn-nav" (click)="mesAnterior()" aria-label="Mes anterior">
      <i class="fas fa-chevron-left"></i>
    </button>

    <div class="mes-anio">
      <h3>{{ nombreMes }} {{ anioActual }}</h3>
    </div>

    <button class="btn-nav" (click)="mesSiguiente()" aria-label="Mes siguiente">
      <i class="fas fa-chevron-right"></i>
    </button>
  </div>

  <!-- Botón "Hoy" -->
  <div class="calendario-actions">
    <button class="btn-hoy" (click)="irHoy()">
      <i class="fas fa-calendar-day"></i>
      Hoy
    </button>
  </div>

  <!-- Días de la semana -->
  <div class="dias-semana">
    <div class="dia-semana-header" *ngFor="let dia of diasSemana">
      {{ dia }}
    </div>
  </div>

  <!-- Grid de días -->
  <div class="dias-grid">
    <div
      *ngFor="let diaCalendario of diasCalendario"
      class="dia-cell"
      [class.hoy]="diaCalendario.esHoy"
      [class.otro-mes]="!diaCalendario.esMesActual"
      [class.seleccionado]="diaCalendario.dia === diaSeleccionado && diaCalendario.mes === mesSeleccionado"
      [class.tiene-efemeride]="diaCalendario.tieneEfemeride"
      (click)="seleccionarDia(diaCalendario)"
      [attr.data-dia]="diaCalendario.dia"
      [attr.data-mes]="diaCalendario.mes"
    >
      <span class="dia-numero">{{ diaCalendario.dia }}</span>
      <span class="dia-indicador" *ngIf="diaCalendario.tieneEfemeride"></span>
    </div>
  </div>

  <!-- Leyenda -->
  <div class="calendario-leyenda">
    <div class="leyenda-item">
      <span class="leyenda-circulo hoy-circulo"></span>
      <span class="leyenda-texto">Hoy</span>
    </div>
    <div class="leyenda-item">
      <span class="leyenda-circulo seleccionado-circulo"></span>
      <span class="leyenda-texto">Seleccionado</span>
    </div>
  </div>
</div>
